import {NotificationService} from "../../services/NotificationService";
import { GrantTypes } from "../../libs/GrantTypes";
import { MqttClientService } from "../../services/MqttClientService";
import { MqttClient } from "../../entities/MqttClient";

export class EditMqttClientCtrl {
    $scope: any;
    originalUsername: string;
    originalPassword: string;
    entity: MqttClient;
    sensorReadingTopic: string;
    alarmTopic: string;
    eventTopic: string;
    gatewayMessageTopic: string;
    tagMovementTopic: string;
    tagObservationTopic: string;
    globalGatewayMessageTopic: string;
    globalTagMovementTopic: string;
    globalTagObservationTopic: string;
    globalEventTopic: string;
    globalAlarmTopic: string;
    globalSensorReadingTopic: string;
    modalInstance:angular.ui.bootstrap.IModalServiceInstance;
    public static $inject = ['$scope', '$uibModalInstance', 'MqttClientService', 'NotificationService', 'mqttClient','companyId'];
    constructor($scope: any, $modalInstance: angular.ui.bootstrap.IModalServiceInstance, public mqttClientService: MqttClientService, public notifyService: NotificationService, mqttClient: MqttClient, companyId:number) {
        this.$scope = $scope;
        this.entity = mqttClient;
        this.originalUsername = mqttClient.username;
        this.originalPassword = mqttClient.password;
        this.modalInstance = $modalInstance;
        this.alarmTopic = "awrx/" + companyId + "/alarm";
        this.eventTopic = "awrx/" + companyId + "/event";
        this.gatewayMessageTopic = "awrx/" + companyId + "/gatewaymsg";
        this.sensorReadingTopic = "awrx/" + companyId + "/sensorreading";
        this.tagMovementTopic = "awrx/" + companyId + "/tagmovement";
        this.tagObservationTopic = "awrx/" + companyId + "/tagobservation";
        this.globalAlarmTopic = "awrx/+/alarm";
        this.globalEventTopic = "awrx/+/event";
        this.globalGatewayMessageTopic = "awrx/+/gatewaymsg";
        this.globalSensorReadingTopic = "awrx/+/sensorreading";
        this.globalTagMovementTopic = "awrx/+/tagmovement";
        this.globalTagObservationTopic = "awrx/+/tagobservation";
        $scope.vm = this;
        if(mqttClient.id == null){
            this.mqttClientService.generateSecret().then((secret) => {
                mqttClient.password = secret;
            })
        }
    }
    newSecret() {
        this.mqttClientService.generateSecret().then((secret) => {
            this.entity.password = secret;
        })
    }
    ok() {

        if (!this.entity.username.match(/^[0-9a-z]+$/i)) {
            this.notifyService.notifyError(("Username must be alpha numeric with no spaces."));
            return;
        }
        if (this.entity.username == null || this.entity.username.length == 0) {
            this.notifyService.notifyError(("Username is required"));
            return;
        }
        if (this.entity.password == null || this.entity.password.length == 0) {
            this.notifyService.notifyError(("Password is required"));
            return;
        }
        //allowRefreshTokens
        this.modalInstance.close(true);
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
